import { Flex, Label, Text } from "@gravity-ui/uikit";
import { ProductDetailResponseDto } from "definitions/product-storage";

import { useProductModalContentTranslate } from "./hooks";
import css from "./ProductModalContent.module.scss";

export const ProductContentDescription = ({
  product,
}: {
  product: ProductDetailResponseDto;
}) => {
  const translations = useProductModalContentTranslate();

  return (
    <Flex direction="column" gap="3" className={css.content}>
      <Flex gap="1" wrap="wrap">
        <Label
          type={"copy"}
          interactive={true}
          value={product.article}
          copyText={product.article}
        >
          {translations.article}
        </Label>
        <Label
          type={"copy"}
          interactive={true}
          value={product.id.toString()}
          copyText={product.id.toString()}
        >
          {translations.productId}
        </Label>
      </Flex>

      {product.description && (
        <Text variant="body-2" color="secondary">
          {product.description}
        </Text>
      )}

      {product.productSources.length > 0 && (
        <Flex gap="1" wrap="wrap">
          <Text variant="subheader-2" color="secondary">
            {translations.productExternalId}
          </Text>
          {product.productSources.map((source) => (
            <Label
              key={source.externalId}
              type={"copy"}
              interactive={true}
              value={source.externalId}
              copyText={source.externalId}
            >
              {source.source}
            </Label>
          ))}
        </Flex>
      )}

      <Flex gap="3" wrap="wrap">
        {product.brand && (
          <Flex direction="column" wrap="wrap">
            <Text variant="subheader-2" color="secondary">
              {translations.brand}
            </Text>
            <div className={css.contentWeight}>{product.brand.name}</div>
          </Flex>
        )}
        {product.category && (
          <Flex direction="column" wrap="wrap">
            <Text variant="subheader-2" color="secondary">
              {translations.category}
            </Text>
            <div className={css.contentWeight}>{product.category.name}</div>
          </Flex>
        )}
      </Flex>
    </Flex>
  );
};
